<template>
    <div :data-toast-id="toastId">
        <h4
            v-if="title"
            class="title"
        >
            {{ title }}
        </h4>
        <span
            v-if="message"
            class="message"
        >{{ message }}</span>
    </div>
</template>

<script lang="ts" setup>
type Props = {
    title?: string,
    message?: string,
    toastId: number;
};

defineProps<Props>();
</script>

<style lang="scss" scoped>
@import '../../../styles/abstracts/font-sizes';

.title {
    font-size: $font-size-lg;
    font-weight: 700;

    color: var(--theme-color-text-primary);
}

.message {
    font-size: $font-size-m;
    white-space: pre-line;
}

</style>
